var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTariffsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 144,
    viewBox: "0 0 140 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 17 1",
    clipPath: "url(#clip0_466_1609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-webapp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LO-Tariff-recommendation-intro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_466_1609",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 9,
    width: 135,
    height: 135
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.21741 9.3913H139.826V144H5.21741V9.3913Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_466_1609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21741 76.6956C5.21741 39.5241 35.3507 9.3913 72.5216 9.3913C109.693 9.3913 139.826 39.5241 139.826 76.6956C139.826 113.867 109.693 144 72.5216 144C35.3507 144 5.21741 113.867 5.21741 76.6956Z",
    fill: "#2B46B1"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.443 66.7301C68.8194 59.8194 70.1623 51.7261 68.49 43.3442C63.8996 20.3315 48.5208 26.978 48.5208 26.978L51.9726 44.2806L37.8219 72.5646L21.9131 75.8078L34.6831 139.826L96 127.326L83.2295 63.3083L66.443 66.7301Z",
    fill: "#8E7EAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.381 82.0995C109.498 77.6671 105.234 74.7986 100.856 75.6926C105.234 74.7986 108.067 70.4811 107.184 66.0482C106.301 61.6158 102.037 58.7478 97.6588 59.6413L76.4029 63.9811C72.0249 64.8751 69.1916 69.1926 70.0741 73.6245C70.9572 78.0574 75.2217 80.9259 79.5997 80.0318C75.2217 80.9259 72.3884 85.2433 73.2715 89.6757C74.154 94.1081 78.419 96.9766 82.7965 96.0831C78.419 96.9766 75.5852 101.295 76.4683 105.727C77.3514 110.159 81.6158 113.027 85.9938 112.134C81.6158 113.027 78.7826 117.345 79.6651 121.778C80.5482 126.21 84.8127 129.079 89.1907 128.185L103.004 125.365C107.381 124.471 110.215 120.153 109.332 115.721C108.449 111.288 104.184 108.42 99.8063 109.314L107.25 107.794C111.628 106.9 114.461 102.583 113.578 98.1502C112.695 93.7178 108.43 90.8493 104.053 91.7434C108.43 90.8493 111.264 86.5319 110.381 82.0995Z",
    fill: "#BAA7C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.087 136.444L12.897 144L0 79.5568L37.1899 72L50.087 136.444Z",
    fill: "#0C1F28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4192 -0.000213623L97.4115 13.0627L113.739 12.1607L104.517 25.7886L110.412 41.1816L94.7206 36.5411L82.0367 46.9565L81.5606 30.4606L67.826 21.5048L83.2239 15.9499L87.4192 -0.000213623Z",
    fill: "url(#paint0_linear_466_1609)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.2 20.8696L126.515 26.385L133.565 26.0042L129.583 31.7583L132.129 38.2575L125.353 36.2983L119.876 40.6957L119.67 33.731L113.739 29.9495L120.388 27.6043L122.2 20.8696Z",
    fill: "url(#paint1_linear_466_1609)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 127.826C24 125.233 26.1024 123.13 28.6959 123.13C31.2889 123.13 33.3913 125.233 33.3913 127.826C33.3913 130.419 31.2889 132.522 28.6959 132.522C26.1024 132.522 24 130.419 24 127.826Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_466_1609",
    x1: 67.826,
    y1: 4695.67,
    x2: 11055.1,
    y2: 4695.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CBA92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_466_1609",
    x1: 113.739,
    y1: 2003.48,
    x2: 4858.26,
    y2: 2003.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CBA92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_1609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 144,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffsIllustration);
export default __webpack_public_path__ + "static/media/tariffs-illustration.92b8111cc18eb5a2077c49b67f40a384.svg";
export { ForwardRef as ReactComponent };